// React and 3rd-party libraries
import React, { useEffect, useState } from "react";
import {
  Dialog,
  Button,
  TextField,
  Box,
  Typography,
  Stack,
  IconButton,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

// Components
import Spinner from "../../components/spinner/Spinner";

// Services
import {
  fetchSasUrl,
  logout,
  uploadToAzureBlob,
} from "../../services/IndiaService";
import { getStorageItemLocal } from "../../services/storageServices";

// Utils / Types / Config
import { CategoryEntry } from "../../services/categoryEntryService";
import { appConfig } from "../../config/appConfig";

// Assets
import cross from "../../assets/close-circle.svg";

// Styles
import "./CategoryFormDialog.scss";

interface IndiaFormDialogProps {
  open: boolean;
  onClose?: () => void;

  fetchData: () => void;
  resetForm: () => void;
  //   categories: any;
  formData: CategoryEntry;
  setFormData: any;
  editingIndex: any;
  setShowForm: any;
  setEditingIndex: any;
  dataList: any;
}

const IndiaFormDialog: React.FC<IndiaFormDialogProps> = ({
  open,
  onClose,
  fetchData,
  resetForm,

  formData,
  setFormData,
  editingIndex,
  setShowForm,
  setEditingIndex,
  dataList,
}) => {
  // useStates
  const [selectedImages, setSelectedImages] = useState<File[]>([]);
  const [selectedPin, setSelectedPin] = useState<File[]>([]);
  const [isChecked, setIsChecked] = useState(false);
  const [thumbnailpreview, setthumbnailpreview] = useState<string>("");
  const [pinpreview, setpinpreview] = useState<string>("");
  const [fileName, setfileName] = useState<string>("");
  const [fileName2, setfileName2] = useState<string>("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  // useNavigate
  const navigate = useNavigate();

  // Constants
  const MAX_FILE_SIZE_MB = 2;
  const ALLOWED_TYPES = ["image/jpeg", "image/jpg", "image/png"];

  // Derived values
  const pinIconPath = Array.isArray(formData.pinIcon)
    ? formData.pinIcon[0]?.trim()
    : formData.pinIcon?.trim();

  const IconPath = Array.isArray(formData.icon)
    ? formData.icon[0]?.trim()
    : formData.icon?.trim();

  // useEffect
  useEffect(() => {
    if (IconPath) {
      const extractedFileName = IconPath.split("/").pop()?.trim() ?? "";

      setfileName(extractedFileName);
    }
    if (pinIconPath) {
      const extractedFileName = pinIconPath.split("/").pop()?.trim() ?? "";

      setfileName2(extractedFileName);
    }
    setIsChecked(formData.isActive);
  }, [formData]);

  //Handle input changes
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    if (value.length > 40) {
      return; // prevent updating formData if length exceeds 120
    }
    setFormData({
      ...formData,
      [name]: value,
      lastUpdated: new Date().toISOString(),
    });
  };

  //handle Image Upload
  const handleImageUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (!files) return;

    const file = files[0];
    const fileExtension = file.name.split(".").pop()?.toLowerCase();
    if (fileExtension === "jfif") {
      setError(`File type .jfif is not allowed: ${file.name}`);
      return;
    }
    if (!ALLOWED_TYPES.includes(file.type)) {
      setError(`Invalid file type: ${file.name}`);
      return;
    }

    if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
      setError(`File size of ${file.name} must be ≤ 2MB.`);
      return;
    }
    setError(null);
    const filesArray = Array.from(files);
    setSelectedImages(filesArray);
    setthumbnailpreview(URL.createObjectURL(file));
    setfileName(file.name);
  };

  //Radio Button
  const handleActive = () => {
    setIsChecked(!isChecked);
  };

  const handlePinUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (!files) return;

    const file = files[0];
    const fileExtension = file.name.split(".").pop()?.toLowerCase();
    if (fileExtension === "jfif") {
      setError(`File type .jfif is not allowed: ${file.name}`);
      return;
    }
    if (!ALLOWED_TYPES.includes(file.type)) {
      setError(`Invalid file type: ${file.name}`);
      return;
    }

    if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
      setError(`File size of ${file.name} must be ≤ 2MB.`);
      return;
    }
    setError(null);
    const filesArray = Array.from(files);
    setSelectedPin(filesArray);
    setpinpreview(URL.createObjectURL(file));
    setfileName2(file.name);
  };

  const uploadToBlob = async (file: File) => {
    let TokenUrl = await fetchSasUrl("file-uploads");
    let pathPrefix = "Categories";
    let fileUrl = await uploadToAzureBlob(
      file,
      "file-uploads",
      TokenUrl,
      pathPrefix,
    );
    // alert(fileUrl);
    return fileUrl.split("?")[0];

    // return fileUrl.split("?")[0] + "/" + file.name;
  };

  const handleSave = async () => {
    if (!formData.name.trim()) {
      alert("Name is required!");
      return;
    }

    setLoading(true);
    try {
      const formDataToSend = new FormData();
      formDataToSend.append("id", editingIndex?.toString() ?? "0");
      // formDataToSend.append("priority", ((editingIndex ?? 0) - 0).toString());
      formDataToSend.append("name", formData.name);
      formDataToSend.append("priority", formData.priority.toString());

      formDataToSend.append("isActive", isChecked.toString());
      formDataToSend.append("status", "Pending"); //Approved  Pending for Approval

      const username = getStorageItemLocal("username") ?? "";
      formDataToSend.append("uploadBy", username);

      if (selectedImages.length > 0) {
        const uploadPromises = selectedImages.map(async (image) => {
          const fileUrl = await uploadToBlob(image);
          formDataToSend.append("icon", fileUrl);
        });
        await Promise.all(uploadPromises); // This ensures all uploads finish before moving forward
      } else if (formData.icon) {
        formDataToSend.append(
          "icon",
          Array.isArray(formData.icon)
            ? formData.icon.join(",")
            : formData.icon || "",
        );
      }

      if (selectedPin.length > 0) {
        const uploadPromises = selectedPin.map(async (image) => {
          const fileUrl = await uploadToBlob(image);
          formDataToSend.append("pinIcon", fileUrl);
        });
        await Promise.all(uploadPromises); // This ensures all uploads finish before moving forward
      } else if (formData.pinIcon) {
        formDataToSend.append(
          "pinIcon",
          Array.isArray(formData.pinIcon)
            ? formData.pinIcon.join(",")
            : formData.pinIcon || "",
        );
      }

      const tokenString = getStorageItemLocal("token");
      const token = tokenString ? JSON.parse(tokenString) : null;
      const url =
        editingIndex !== null
          ? `${appConfig.serviceUrls.saveCategory}/${formData.id}`
          : `${appConfig.serviceUrls.saveCategory}/upload`;

      const response = await fetch(url, {
        method: editingIndex !== null ? "PUT" : "POST",
        body: formDataToSend,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 401) {
        logout(navigate);
        <Button onClick={() => logout(navigate)}>Logout</Button>;
        return;
      }
      if (!response.ok) throw new Error("Failed to save data");
      alert("Data saved successfully");
      fetchData();
      resetForm();
      const imageUploadInput = document.getElementById(
        "imageUpload",
      ) as HTMLInputElement | null;
      if (imageUploadInput) imageUploadInput.value = "";
      setSelectedImages([]);
      setEditingIndex(null);
      setShowForm(false);
      handleCancel();
    } catch (error) {
      console.error("Error saving data:", error);
      alert("Failed to save data");
    } finally {
      setLoading(false);
    }
  };
  const handleCancel = () => {
    onClose?.();
    setthumbnailpreview("");
    setpinpreview("");
    setSelectedImages([]);
    setSelectedPin([]);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{
        sx: {
          width: "90%",
          height: "95%",
        },
      }}
    >
      {/* header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "#F7F7F7",
          padding: "15px 16px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center", // center the items vertically
            gap: 1, // adds spacing between icon and text
          }}
        >
          <Typography className="custom-icon-text">
            {editingIndex !== null ? "Edit Category" : "Add Category"}
          </Typography>
        </Box>
        <Box className="cross-btn">
          <IconButton
            color="primary"
            size="small"
            onClick={handleCancel}
            className="custom-icon-button2"
          >
            <img src={cross} alt="visible" className="custom-icon2" />
          </IconButton>
        </Box>
      </Box>

      {/* body //////////////////////*/}
      {loading ? (
        <>
          {" "}
          <Spinner></Spinner>
        </>
      ) : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-around",
            alignItems: "flex-start",
            background: "#FFF",
            padding: "25px 16px",
          }}
        >
          {/* 1st box */}
          <Box>
            <TextField
              // disabled={editingIndex !== null}
              label="CategoryName"
              name="name"
              value={formData.name}
              onChange={handleChange}
              size="small"
              className="custom-select"
            ></TextField>
            <Typography className="pdf-name-count1 ">
              {formData.name?.length || 0}/40
            </Typography>
            <Box sx={{ paddingBottom: "35px" }} />

            <Typography>
              {" "}
              <b>Menu Icon </b>{" "}
            </Typography>
            <Box className="pdf-upload-row">
              <Box className="pdf-name-wrapper">
                <TextField
                  placeholder="Choose Icon"
                  size="small"
                  name="pdfName"
                  value={fileName}
                  onChange={handleChange}
                  variant="standard"
                  fullWidth
                  disabled={true}
                  InputProps={{ disableUnderline: true }}
                />
              </Box>

              <Box>
                <Button component="label" className="choose-pdf-button">
                  <Typography className="pdf-button-text ">Browse</Typography>
                  <input
                    id="pdfUpload"
                    type="file"
                    accept="image/jpeg, image/png"
                    onChange={handleImageUpload}
                    hidden
                    //   onChange={handlePdfUpload}
                  />
                </Button>
                {/* {pdferror && <Alert severity="error">{pdferror}</Alert>} */}
              </Box>
            </Box>
            <Typography className="image-note">
              Note: The Menu Icon resolution should be 500 × 500 and should be
              in .png format.
            </Typography>
            {/* Pin Icon */}
            <Box sx={{ paddingBottom: "35px" }} />

            <Typography>
              {" "}
              <b>Map Pin </b>{" "}
            </Typography>
            <Box className="pdf-upload-row">
              <Box className="pdf-name-wrapper">
                <TextField
                  placeholder="Choose Map pin"
                  size="small"
                  name="pdfName"
                  value={fileName2}
                  onChange={handleChange}
                  variant="standard"
                  fullWidth
                  disabled={true}
                  InputProps={{ disableUnderline: true }}
                />
              </Box>

              <Box>
                <Button component="label" className="choose-pdf-button">
                  <Typography className="pdf-button-text ">Browse</Typography>
                  <input
                    id="pdfUpload"
                    type="file"
                    accept="image/jpeg, image/png"
                    onChange={handlePinUpload}
                    hidden
                  />
                </Button>
                {/* {pdferror && <Alert severity="error">{pdferror}</Alert>} */}
              </Box>
            </Box>
            <Typography className="image-note">
              The Map Pin resolution should be 500 × 700 and should be in .png
              format.
            </Typography>

            <Box className="check-box">
              <Typography className="text-style">
                <b> Active/Disable</b>
              </Typography>

              <Box
                onClick={handleActive}
                sx={{ padding: "15px" }}
                className="status-wrapper"
              >
                <Box
                  onChange={handleActive}
                  className={`status-toggle1 ${
                    isChecked ? "active" : "Disable"
                  }`}
                >
                  <Box className="status-circle" />
                </Box>

                <Typography
                  sx={{ width: "30px" }}
                  className="active-txt"
                  component="span"
                >
                  {isChecked ? "Active" : "Disable"}
                </Typography>
              </Box>
            </Box>
          </Box>
          {/* 2nd Box */}
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-around !important",
            }}
          >
            <Box sx={{ paddingRight: "5px" }} className="thumbnail-frame">
              {selectedImages.length > 0 ? (
                <img
                  loading="lazy"
                  src={thumbnailpreview}
                  alt="Icon"
                  width={206}
                  height={206}
                />
              ) : IconPath ? (
                <img
                  loading="lazy"
                  // loading="lazy"
                  src={IconPath}
                  // src={`${API_BASE_URL1}${formData.icon.trim()}`}
                  alt=" Icon"
                  width={206}
                  height={206}
                />
              ) : (
                <Typography>Icon Preview</Typography>
              )}
            </Box>
            {/* pinIcon */}
            <Box className="thumbnail-frame">
              {selectedPin.length > 0 ? (
                <img
                  loading="lazy"
                  src={pinpreview}
                  alt="Icon"
                  width={206}
                  height={206}
                />
              ) : pinIconPath ? (
                <img
                  loading="lazy"
                  // loading="lazy" //src={`https://localhost:44354${img}`}
                  src={pinIconPath}
                  alt="Pin Icon"
                  width={206}
                  height={206}
                />
              ) : (
                <Typography>PinIcon Preview</Typography>
              )}
            </Box>
          </Box>
        </Box>
      )}

      {/* Action button ////////////////////////// */}
      <Stack
        className="action-button"
        direction="row"
        spacing={2}
        justifyContent="flex-end"
      >
        {/* <Button onClick={() => handleClear()} className="clear-button1">
          Clear
        </Button> */}

        <Button onClick={handleCancel} className="cancel-button">
          Cancel
        </Button>
        <Button
          //   disabled={error != null || viderror != null}
          onClick={handleSave}
          className="save-button"
        >
          {editingIndex !== null ? "Update" : "Save"}{" "}
        </Button>
      </Stack>
    </Dialog>
  );
};

export default IndiaFormDialog;
